import React from 'react';
import { withRouter } from 'react-router-dom';

// mui
import { styled } from '@mui/material/styles';
import MuiChip from '@mui/material/Chip';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import { twilight } from 'lib/v2/colors';

const StyledChip = styled(MuiChip, {
  shouldForwardProp: (prop) => prop !== 'withLink',
})(({ theme, withLink }) => ({
  ...(withLink && {
    textDecoration: 'underline',
    color: twilight,
    '& .MuiChip-icon': {
      color: twilight,
    },
  }),
}));

const TswChip = ({ label, url, linksEnabled, history, ...rest }) => {
  const isExternalLink = url && url.includes('http');
  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isExternalLink) window.open(url, '_blank');
    else history.push(url);
  };

  let chipProps = {
    ...rest,
    label,
  };

  if (url && linksEnabled) {
    chipProps = {
      ...chipProps,
      onClick,
      onDelete: null,
      withLink: true,
    };

    if (isExternalLink) {
      chipProps.icon = <OpenInNewIcon />;
    }
  }

  return <StyledChip {...chipProps} key={chipProps.key} />;
};

export default withRouter(TswChip);
